"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useLinking_native_exports = {};
__export(useLinking_native_exports, {
  useLinking: () => useLinking
});
module.exports = __toCommonJS(useLinking_native_exports);
var import_core = require("@react-navigation/core");
var React = __toESM(require("react"), 1);
var import_react_native = require("react-native");
var import_getNavigateAction = require("../router/utils/getNavigateAction");
var import_extractPathFromURL = require("./extractPathFromURL");
var linkingHandlers = /* @__PURE__ */ new Set();
function stripRouteKeys(state) {
  return {
    ...state,
    routes: state.routes.map(function(route) {
      var { key, ...rest } = route;
      return rest.state ? {
        ...rest,
        state: stripRouteKeys(rest.state)
      } : rest;
    })
  };
}
function useLinking(ref, param) {
  var { enabled = true, prefixes, filter, config, getInitialURL = function() {
    return Promise.race([
      import_react_native.Linking.getInitialURL(),
      new Promise(function(resolve) {
        setTimeout(resolve, 150);
      })
    ]);
  }, subscribe = function(listener) {
    var _Linking_removeEventListener;
    var callback = function callback2(param2) {
      var { url } = param2;
      return listener(url);
    };
    var subscription = import_react_native.Linking.addEventListener("url", callback);
    var removeEventListener = (_Linking_removeEventListener = import_react_native.Linking.removeEventListener) === null || _Linking_removeEventListener === void 0 ? void 0 : _Linking_removeEventListener.bind(import_react_native.Linking);
    return function() {
      if (subscription === null || subscription === void 0 ? void 0 : subscription.remove) {
        subscription.remove();
      } else {
        removeEventListener === null || removeEventListener === void 0 ? void 0 : removeEventListener("url", callback);
      }
    };
  }, getStateFromPath = import_core.getStateFromPath, getActionFromState = import_core.getActionFromState } = param;
  var independent = (0, import_core.useNavigationIndependentTree)();
  React.useEffect(function() {
    if (process.env.NODE_ENV === "production") {
      return void 0;
    }
    if (independent) {
      return void 0;
    }
    if (enabled !== false && linkingHandlers.size && import_react_native.Platform.OS !== "android") {
      if (linkingHandlers.size > 1) {
        console.error([
          "Looks like you have configured linking in multiple places. This is likely an error since deep links should only be handled in one place to avoid conflicts. Make sure that:",
          "- You don't have multiple NavigationContainers in the app each with 'linking' enabled",
          "- Only a single instance of the root component is rendered"
        ].join("\n").trim());
      }
    }
    var handler = /* @__PURE__ */ Symbol();
    if (enabled !== false) {
      linkingHandlers.add(handler);
    }
    return function() {
      linkingHandlers.delete(handler);
    };
  }, [
    enabled,
    independent
  ]);
  var enabledRef = React.useRef(enabled);
  var prefixesRef = React.useRef(prefixes);
  var filterRef = React.useRef(filter);
  var configRef = React.useRef(config);
  var getInitialURLRef = React.useRef(getInitialURL);
  var getStateFromPathRef = React.useRef(getStateFromPath);
  var getActionFromStateRef = React.useRef(getActionFromState);
  React.useEffect(function() {
    enabledRef.current = enabled;
    prefixesRef.current = prefixes;
    filterRef.current = filter;
    configRef.current = config;
    getInitialURLRef.current = getInitialURL;
    getStateFromPathRef.current = getStateFromPath;
    getActionFromStateRef.current = getActionFromState;
  });
  var getStateFromURL = React.useCallback(function(url) {
    var _prefixesRef_current;
    if (!url || filterRef.current && !filterRef.current(url)) {
      return void 0;
    }
    var path = (0, import_extractPathFromURL.extractPathFromURL)((_prefixesRef_current = prefixesRef.current) !== null && _prefixesRef_current !== void 0 ? _prefixesRef_current : [], url);
    return path !== void 0 ? getStateFromPathRef.current(path, configRef.current) : void 0;
  }, []);
  var getInitialState = React.useCallback(function() {
    var state;
    if (enabledRef.current) {
      var url = getInitialURLRef.current();
      if (url != null) {
        if (typeof url !== "string") {
          return url.then(function(url2) {
            return getStateFromURL(url2);
          });
        }
      }
      state = getStateFromURL(url);
    }
    var thenable = {
      // biome-ignore lint/suspicious/noThenProperty: don't check copied code
      then(onfulfilled) {
        return Promise.resolve(onfulfilled ? onfulfilled(state) : state);
      },
      catch() {
        return thenable;
      }
    };
    return thenable;
  }, [
    getStateFromURL
  ]);
  React.useEffect(function() {
    var listener = function listener2(url) {
      if (!enabled) {
        return;
      }
      var navigation = ref.current;
      var state = navigation ? getStateFromURL(url) : void 0;
      if (navigation && state) {
        var rootState = navigation.getRootState();
        if (state.routes.some(function(r) {
          var _rootState_routeNames;
          return !(rootState === null || rootState === void 0 ? void 0 : (_rootState_routeNames = rootState.routeNames) === null || _rootState_routeNames === void 0 ? void 0 : _rootState_routeNames.includes(r.name));
        })) {
          return;
        }
        var action = getActionFromStateRef.current === import_core.getActionFromState ? rootState ? (0, import_getNavigateAction.getNavigateAction)(state, rootState) : void 0 : getActionFromStateRef.current(stripRouteKeys(state), configRef.current);
        if (action !== void 0) {
          try {
            navigation.dispatch(action);
          } catch (e) {
            console.warn(`An error occurred when trying to handle the link '${url}': ${typeof e === "object" && e != null && "message" in e ? e.message : e}`);
          }
        } else {
          navigation.resetRoot(state);
        }
      }
    };
    return subscribe(listener);
  }, [
    enabled,
    getStateFromURL,
    ref,
    subscribe
  ]);
  return {
    getInitialState
  };
}
//# sourceMappingURL=useLinking.native.js.map
